import {
  getDistrictStoreCodes,
  getAllRelatedKpis,
} from "../helpers/calc_consts.ts";
import {
  GetReportingSumDataByLocationFidaV2OnlyExport,
  GetReportingSumDataFidaV2
  
} from '../api/fida.ts';
// import overviewData from "../core/json/dummyData/overview.json";
import { fillEmptyData } from "../helpers/empty_data.ts";
import convertor from "../helpers/fidaToOldConverter.ts";
import trendCalc from "../helpers/trend_calc.ts";
import store from "../core/redux/store.jsx";
import {APIGetUserLocations} from "../api/stores.ts"
// import {APIFetchStores} from "../helpers/filterstores.ts"

let storeData: any = null;
let storeNamesbyCode = {};
export function APIFetchOverview(params) {
  return fetchAllDetail(params);
  // return PostRequest('kpis', params);
}


export function APIFetchOverviewDateHourly(params) {
  return fetchAllDetailDateHourly(params);
  // return PostRequest('kpis', params);
}


// check value arrives of all stores
let allStoresB = {};
let listStore = {};
store.subscribe(() => {
  const { stores } = store.getState();
  listStore = stores.stores
  const { apiStores } = stores;
  allStoresB = apiStores;
});

async function getStoreData() {
//   let hasData = localStorage.getItem('dashboardManager.hasStoreData')
  let hasData = allStoresB
  const isEmptyOrNull = Object.values(hasData).every(value => value === null || (Array.isArray(value) && value.length === 0));
  if (isEmptyOrNull) {
    allStoresB = (await APIGetUserLocations()).response;
    Object.values(allStoresB).forEach((gS:any) => {
      gS.forEach((s) => {
        storeNamesbyCode[s.storeNumber] = s.title
      })
    })
  }
  return allStoresB;
}
//
async function fetchAllDetailDateHourly(params) {
  const userKPIs = params.kpis;
  
  let allKpis = userKPIs;//getAllRelatedKpis(userKPIs);

  let freq = params.startDate == params.endDate ? "hourly" : "daily";
  if(params.frequency == "hourly")
  {
    freq =  "hourly" 
  }
  
  let dateT = freq == "daily" ? "date" : "hour";
  
 

  let startDate = params.startDate;
  let endDate = params.endDate;
  let compareStartDate = params.compareStartDate;
  let compareEndDate = params.compareEndDate;

  let newParam = {
    startDate,
    endDate,
    compareStartDate,
    compareEndDate,
    storeCodes: params.storeCodes,
    kpiTypes: allKpis,
    frequency: freq,
    days: params.days,
    summary: 1,
  };
  if(!startDate) return [];
  const resp1 = await GetReportingSumDataFidaV2(newParam);

  console.log('overviewresp1 Daily Houly',resp1)
  storeData = await getStoreData();
  if (!resp1) {
    return {};
  }
  console.log('await makeKpisDataDashboard',);
  
  const d = await makeKpisDataDashboard(resp1, params, userKPIs, dateT, freq, newParam)
  console.log('await makeKpisDataDashboard-d',d);
  
  const data={dashboard: d, byPeriod: makeByPeriodData(resp1, params, dateT, freq, allKpis)}
  console.log('await makeKpisDataDashboard-data',data);
  

  return data;
  
}

async function fetchAllDetail(params) {
  const userKPIs = params.kpis;
  
  let allKpis = userKPIs;//getAllRelatedKpis(userKPIs);

  let freq = params.startDate == params.endDate ? "hourly" : "daily";
  if(params.frequency == "hourly")
  {
    freq =  "hourly" 
  }
  
  let dateT = freq == "daily" ? "date" : "hour";
  
 

  let startDate = params.startDate;
  let endDate = params.endDate;
  let compareStartDate = params.compareStartDate;
  let compareEndDate = params.compareEndDate;

  let newParam = {
    startDate,
    endDate,
    compareStartDate,
    compareEndDate,
    storeCodes: params.storeCodes,
    kpiTypes: allKpis,
    frequency: freq,
    days: params.days,
    summary: 1,
  };
  if(!startDate) return [];
  const resp1 = await GetReportingSumDataByLocationFidaV2OnlyExport(newParam);

  console.log('overviewresp1',resp1)
  storeData = await getStoreData();
  if (!resp1) {
    return {};
  }
  console.log('await makeKpisDataDashboard',);
  const d = await makeKpisDataDashboard(resp1, params, userKPIs, dateT, freq, newParam)
  const data={dashboard: d, byPeriod: makeByPeriodData(resp1, params, dateT, freq, allKpis)}
  return data;
  
}
function makeByPeriodData(apiData, params, dateT, freq, allKpis){
  let resp1: any = {};
  resp1 = apiData
  convertor.formatV2Resp(resp1, dateT)
  const [st1, d1] = convertor.getCount(resp1?.kpis || [], dateT)
  const [st2, d2] = convertor.getCount(resp1?.compare || [], dateT)
  let area = convertor.getArea(resp1.kpis, storeData)
  let cArea = convertor.getArea(resp1.compare, storeData)
  let bValues = convertor.sumAll(resp1.kpis, freq == 'daily' ? 'date' : 'hour', area)
  let bCValues = convertor.sumAll(resp1.compare, freq == 'daily' ? 'date' : 'hour', cArea)
  let retVal = convertor.getConvertedValues(bValues, bCValues, resp1.kpis, resp1.compare, { storeCount: params.storeCodes.length, area, cArea, st1, d1, st2, d2, userKPIs: allKpis  });
 return { data: [{ kpis: retVal}]};
}

async function makeKpisDataDashboard(apiData, params, userKPIs, dateT, freq, newParam){
  let resp1: any = {};
  resp1 = apiData;
  fillEmptyData(resp1.kpis, {
    startDate: params.startDate,
    endDate: params.endDate,
    storeCodes: params.storeCodes,
    userKPIs,
    stores: resp1.stores || storeData.dataAccessStores,
  });
  fillEmptyData(resp1.compare, {
    startDate: params.compareStartDate,
    endDate: params.compareEndDate,
    storeCodes: params.storeCodes,
    userKPIs,
    stores: resp1.stores || storeData.dataAccessStores,
  });

  convertor.formatV2Resp(resp1, dateT);
  const [st1, d1] = convertor.getCount(resp1?.kpis || [], dateT);
  const [st2, d2] = convertor.getCount(resp1?.compare  || [], dateT);
  let area = convertor.getArea(resp1.kpis, storeData);
  let cArea = convertor.getArea(resp1.compare, storeData);
  let compareData = await sortRespByLocation(
    params,
    ["regions", "districts", "stores", "peerGroups", "areaManagers"],
    JSON.parse(JSON.stringify(resp1)),
    { kpis: userKPIs }
  );
  let trendR = JSON.parse(JSON.stringify(resp1));
  let allTrends = {};
  const trendKPIs = JSON.parse(JSON.stringify(userKPIs));
  trendKPIs.push("targetrate");
  trendKPIs.forEach((t) => {
    let thisTrend = trendCalc.sumTrendKPI(
      trendR.kpis,
      trendR.compare,
      t.toLowerCase(),
      dateT,
      {
        area,
        cArea,
        userKPIs,
        startDate: params.startDate,
        compareStartDate: params.compareStartDate,
      }
    );
    thisTrend.data.selectedPeriod = thisTrend.data.selectedPeriod.sort(
      (a, b) => {
        return (
          new Date(a.timeLabel).getTime() - new Date(b.timeLabel).getTime()
        );
      }
    );
    thisTrend.data.comparedPeriod = thisTrend.data.comparedPeriod.sort(
      (a, b) => {
        return (
          new Date(a.timeLabel).getTime() - new Date(b.timeLabel).getTime()
        );
      }
    );
    allTrends[thisTrend.compatibleKey] = thisTrend;
  });
  let retVal;

  // if(resp1.kpisSummary && resp1.compareSummary && Object.keys(resp1.compareSummary).length>0) {
  //   retVal = convertor.getConvertedValuesSimplified(resp1.kpisSummary, resp1.compareSummary)
  // } else {
  let bValues = convertor.sumAll(
    resp1.kpis,
    freq == "daily" ? "date" : "hour",
    area
  );
  let bCValues = convertor.sumAll(
    resp1.compare,
    freq == "daily" ? "date" : "hour",
    cArea
  );
  retVal = convertor.getConvertedValues(
    bValues,
    bCValues,
    resp1.kpis,
    resp1.compare,
    {
      storeCount: params.storeCodes.length,
      area,
      cArea,
      st1,
      d1,
      st2,
      d2,
      userKPIs,
    }
  );
  // }
  return { data: [{ kpis: retVal }], compareData, allTrends, params: newParam };
}
export function getStoreGroupsByStoreCodeList(storeCodes) {
  const storeCodesListArray = storeCodes;
  const data:any = listStore;
  const uniqueResults = new Set(); // Use a Set to store unique results

  for (const storeCode of storeCodesListArray) {
    const result:any = {};

    // Find area managers that have the given storeCode
    for (const areaManager of data.areaManagers) {
      for (const store of areaManager.stores) {
        if (store.storeCode === storeCode) {
          result.areaManagerName = areaManager.name;
          break;
        }
      }
      if (result.areaManagerName) break;
    }

    // Find regions and districts that have the given storeCode
    for (const region of data.regions) {
      for (const district of region.districts) {
        for (const store of district.stores) {
          if (store.storeCode === storeCode) {
            result.regionName = region.name;
            result.districtName = district.name;
            break;
          }
        }
        if (result.regionName) break;
      }
      if (result.regionName) break;
    }

    // Find peer groups that have the given storeCode
    result.peerGroups = [];
    for (const peerGroup of data.peerGroups) {
      for (const store of peerGroup.stores) {
        if (store.storeCode === storeCode) {
          result.peerGroups.push(peerGroup.name);
          break;
        }
      }
    }

    // Convert the result to a string to check for uniqueness
    const resultString = JSON.stringify(result);

    if (!uniqueResults.has(resultString)) {
      uniqueResults.add(resultString);
    }
  }

  // Convert the Set back to an array of unique results
  const uniqueResultsArray = Array.from(uniqueResults).map((resultString:any) =>
    JSON.parse(resultString)
  );

  // Create an object with comma-separated unique values
  const uniqueResultsObj = {
    areaManagers: [...new Set(uniqueResultsArray.map((result) => result.areaManagerName))].join(','),
    regions: [...new Set(uniqueResultsArray.map((result) => result.regionName))].join(','),
    districts: [...new Set(uniqueResultsArray.map((result) => result.districtName))].join(','),
    peerGroups: [...new Set(uniqueResultsArray.flatMap((result) => result.peerGroups))].join(','),
  };
  return uniqueResultsObj;
}
async function sortRespByLocation(params, types, resp, extData) {
  let retVal = {};
  storeData = await getStoreData();
  types.forEach((type) => {
    let storeGroupsByStoreCodeList;
    let allStores = "";
    let typedStores = {};
    if (type == "districts") {
      storeGroupsByStoreCodeList = getStoreGroupsByStoreCodeList(params.storeCodes);
      let names = storeGroupsByStoreCodeList[type]?.split(',')?.map((name) => name.trim());
      for (let i = 0; i < names?.length; i++) {
        let cS = getDistrictStoreCodes(storeData, type, names[i]) + ",";
        allStores += cS;
        typedStores[names[i]] = cS;
      }
    } else if (type != "stores") {
      storeGroupsByStoreCodeList = getStoreGroupsByStoreCodeList(params.storeCodes);
      let names = storeGroupsByStoreCodeList[type]?.split(',')?.map((name) => name.trim());
      for (let i = 0; i < names?.length; i++) {
        let cS = getStoreCodesByLocations(type, names[i]) + ",";
        allStores += cS;
        typedStores[names[i]] = cS;
      }
    } else {
      allStores = params.storeCodes;
      params.storeCodes.forEach((s) => {
        typedStores[s] = s;
      });
    }
    console.log(allStores);
    let area = convertor.getArea(resp.kpis, storeData);

    retVal[type] = convertor.formatComparisionByLocation(
      resp,
      typedStores,
      type,
      params.comparisonYKPIMetricKey,
      storeNamesbyCode,
      area,
      extData
    );
  });

  return retVal;
}
export function getStoreCodesByLocations(groupType, name) {
  // const data = store.getters['user/getStoreGroups'];
  const data:any = listStore
  if (groupType === "areaManagers") {
    const areaManager = data.areaManagers.find(
      (manager) => manager.name === name
    );
    if (areaManager) {
      return areaManager.stores.map((store) => store.storeCode);
    }
  } else if (groupType === "regions") {
    const region = data.regions.find((region) => region.name === name);
    if (region) {
      const storeCodes:any = [];
      region.districts.forEach((district) => {
        storeCodes.push(...district.stores.map((store) => store.storeCode));
      });
      return storeCodes;
    }
  } else if (groupType === "peerGroups") {
    const peerGroup = data.peerGroups.find((group) => group.name === name);
    if (peerGroup) {
      return peerGroup.stores.map((store) => store.storeCode);
    }
  } else if (groupType === "districts") {
    const district = data.regions
      .flatMap((region) => region.districts)
      .find((district) => district.name === name);
    if (district) {
      return district.stores.map((store) => store.storeCode);
    }
  }

  return [];
}